
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11205",
                "data-name": "矩形 11205",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.004 -0.207)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_245",
        "data-name": "蒙版组 245",
        "class": "cls-2",
        "transform": "translate(0.004 0.207)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "airconditioning",
            "transform": "translate(2.996 3.793)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7751",
                "data-name": "路径 7751",
                "class": "cls-3",
                "d": "M61.276,123.425a.528.528,0,0,0-.787,0,.587.587,0,0,0,0,.824,1.479,1.479,0,0,1,0,1.882,2.7,2.7,0,0,0,0,3.412.577.577,0,0,0,.45.235.4.4,0,0,0,.337-.118.587.587,0,0,0,0-.824,1.479,1.479,0,0,1,0-1.882A2.848,2.848,0,0,0,61.276,123.425Zm5.062,0a.528.528,0,0,0-.787,0,.587.587,0,0,0,0,.824,1.479,1.479,0,0,1,0,1.882,2.7,2.7,0,0,0,0,3.412.577.577,0,0,0,.45.235.4.4,0,0,0,.338-.118.587.587,0,0,0,0-.824,1.479,1.479,0,0,1,0-1.882A2.848,2.848,0,0,0,66.339,123.425Zm5.063,0a.528.528,0,0,0-.787,0,.587.587,0,0,0,0,.824,1.479,1.479,0,0,1,0,1.882,2.7,2.7,0,0,0,0,3.412.577.577,0,0,0,.45.235.4.4,0,0,0,.338-.118.587.587,0,0,0,0-.824,1.479,1.479,0,0,1,0-1.882A2.848,2.848,0,0,0,71.4,123.425Zm2.362-9.647H58.014a1.088,1.088,0,0,0-1.125,1.176v4.118a2.851,2.851,0,0,0,2.813,2.941H72.076a2.851,2.851,0,0,0,2.812-2.941v-4.118A1.088,1.088,0,0,0,73.764,113.778Zm0,5.294a1.771,1.771,0,0,1-1.687,1.765H59.7a1.771,1.771,0,0,1-1.688-1.765v-4.118h15.75Z",
                "transform": "translate(-56.889 -113.778)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7752",
                "data-name": "路径 7752",
                "class": "cls-3",
                "d": "M171.24,313.951h9.74a.533.533,0,1,0,0-1.062h-9.74a.533.533,0,1,0,0,1.062Zm11.459,0h1.146a.533.533,0,1,0,0-1.062H182.7a.533.533,0,1,0,0,1.062Z",
                "transform": "translate(-168.542 -308.74)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  